interface Props {
  isSelected?: boolean;
}

const CheckboxIcon = ({ isSelected }: Props) => {
  return isSelected ? (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.4 0H3.6C1.56 0 0 1.56 0 3.6V20.4C0 22.44 1.56 24 3.6 24H20.4C22.44 24 24 22.44 24 20.4V3.6C24 1.56 22.44 0 20.4 0ZM21.6 20.4C21.6 21.12 21.12 21.6 20.4 21.6H3.6C2.88 21.6 2.4 21.12 2.4 20.4V3.6C2.4 2.88 2.88 2.4 3.6 2.4H20.4C21.12 2.4 21.6 2.88 21.6 3.6V20.4Z"
        fill="white"
      />
      <path d="M9.5998 13.92L6.4798 10.8L4.7998 12.48L9.5998 17.28L19.1998 7.68L17.5198 6L9.5998 13.92Z" fill="white" />
    </svg>
  ) : (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.4 0H3.6C1.56 0 0 1.56 0 3.6V20.4C0 22.44 1.56 24 3.6 24H20.4C22.44 24 24 22.44 24 20.4V3.6C24 1.56 22.44 0 20.4 0ZM21.6 20.4C21.6 21.12 21.12 21.6 20.4 21.6H3.6C2.88 21.6 2.4 21.12 2.4 20.4V3.6C2.4 2.88 2.88 2.4 3.6 2.4H20.4C21.12 2.4 21.6 2.88 21.6 3.6V20.4Z"
        fill="white"
        fillOpacity="0.14"
      />
    </svg>
  );
};

export default CheckboxIcon;
